__webpack_require__.p = "/reports-concurrency-issues/referrals-hub/";